export default __webpack_public_path__ + "static/media/happy_non-binary.933f4a85.png";